export default class ScheduleListRow {
	static get ITEM_TYPE() {
		const ITEM_TYPE = {
			UNKNOWN: 0,
			PROJECT: 1,
			MEMBER: 2,
			TASK: 3,
		};
		return ITEM_TYPE;
	}
	
	get isProject() { return this.item_type === ScheduleListRow.ITEM_TYPE.PROJECT }
	get isMember() { return this.item_type === ScheduleListRow.ITEM_TYPE.MEMBER }
	get isTask() { return this.item_type === ScheduleListRow.ITEM_TYPE.TASK }

	constructor(params) {
		if (params.item_type !== undefined)
			this.item_type = params.item_type;
		else
			this.item_type = ScheduleListRow.ITEM_TYPE.UNKNOWN;

		this.code = params.code;
		this.seq = params.seq;
		this.name = params.name;

		if (params.classes !== undefined)
			this.classes = params.classes;
		else
			this.classes = new Array();

		if (params.children !== undefined)
			this.children = params.children;
		else
			this.children = new Array();

		if(params.is_updated !== undefined) {
			this.is_updated = params.is_updated;
		} else {
			this.is_updated = true;
		}
		
		if(params.remarks !== undefined)
			this.remarks = params.remarks;
		else
			this.remarks = '';
	}
}